
import lazyLoad from "@/utils/lazyload";


export type IRoute =  {
    name: string;         //菜单名称
    key: string;          //菜单key
    path?: string;          //菜单path
    breadcrumb?: boolean; // 当前页是否展示面包屑
    component?: any;     // 当前页是否展示面包屑
    children?: IRoute[];  //子节点
    ignore?: boolean;     // 当前路由是否渲染菜单项，为 true 的话不会在菜单中显示，但可通过路由地址访问。
    auth?:boolean;        //需要授权登录
    defaultRoute?:boolean;//启动默认路由
    notPage?:boolean;      //不是页面
    level?: number         //路由等级 -1不是路由 1一级路由 2二级路由 ...
    cache?: boolean;       //默认fales
};

export function getRoute(routes) {
    const res = [];
    function travel(_routes) {
        if(!_routes){
            return
        }
        _routes.forEach((route) => {
            if(route.level === -1) {
                if(route.children && route.children.length) {
                    travel(route.children);
                }
            }else if(route.level === 1){
                if (route.key) {
                    try {
                        if(!route.component) {
                            route.component = lazyLoad(() => import(
                                /* webpackInclude: /[\\/]index\.tsx$/ */
                                `@/pages/${route.key}`
                            ))
                        } 
                        res.push(route);
                    } catch (e) {
                        console.error(e);
                    }
                }
                if (route.children && route.children.length) {
                    travel(route.children);
                }
            }
        });
    }
    travel(routes);
    return res;
}
